import { IconLayer } from '@deck.gl/layers';

import colouredFragmentShader from './shaders/coloured-fragment-shader.glsl';

export default class ColouredIconLayer extends IconLayer {
  getShaders() {
    return { ...super.getShaders(), fs: colouredFragmentShader };
  }
}
